import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { AppLink } from 'lib/app/app-link';
import { TrackingLink } from 'lib/app/tracking-link';
import { CdnImagePath } from 'lib/cdn-image-path';
import usePlatform, { PlatformType } from 'lib/use-platform';

import { onClickWhatsNewDateCta } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';
import { P1 } from 'components/typography';

export const SuperswipeBlockOneContainer: FunctionComponent = () => {
    const platform = usePlatform();
    const ctaLink: { [key in PlatformType]: string } = {
        [PlatformType.ios]: TrackingLink.APP_STORE_IOS,
        [PlatformType.android]: TrackingLink.GOOGLE_PLAY_STORE,
        [PlatformType.ie11]: AppLink.BUMBLE_GET_STARTED,
        [PlatformType.edge]: AppLink.BUMBLE_GET_STARTED,
        [PlatformType.unknown]: AppLink.BUMBLE_GET_STARTED,
    };

    const props = {
        imageSrc: `${CdnImagePath}/landing/assets/photos/features/superswipe/superswipe-block-1-image.jpg`,
        imageAlt: '',
        imageObjectPosition: '65% 10%',
        title: features.superswipe.lxSuperswipeOneBlockTitle,
        text: features.superswipe.lxSuperswipeOneBlockBodyText,
        actionText: features.superswipe.lxFeaturesDownloadBumbleCta,
        actionUrl: ctaLink[platform],
    };

    return (
        <PageSectionCta
            title={props.title}
            text={<P1 html={props.text}></P1>}
            action={{
                text: props.actionText,
                href: props.actionUrl,
                onClick: onClickWhatsNewDateCta,
            }}
            image={{
                src: props.imageSrc,
                objectPosition: props.imageObjectPosition,
            }}
            color="orange"
        />
    );
};
